import React, {useState} from 'react';
import {useQuery} from 'react-query';
import {IOfferWithRewards} from 'types/offers';
import {BREAKPOINTS, QUERY_KEYS} from '../../../../constants';
import {DialogRoot, DialogTrigger, Skeleton, Table} from '@chakra-ui/react';
import Text from 'components/typografy/text';
import styles from './styles.module.scss';
import {Avatar} from 'components/chakra-ui/avatar';
import useWindowSize from 'hooks/useWindowSize';
import {IoChevronForwardOutline} from 'react-icons/io5';
import DialogContent from '../completed/dialog-content';
import Dialog from '../../../../components/dialog';
import TabsSkeleton from '../skeleton';
import {rewardsHistory} from 'api/user';
import {toTitleCase} from 'helpers';
import {ReactComponent as CashIcon} from 'svg/cash2.svg';



const Completed: React.FC = () => {
  const {width} = useWindowSize();
  const [isOpen, setIsOpen] = useState(false);
  const [activeItem, setActiveItem] = useState<IOfferWithRewards | null>();  // State to select item (in small screens) it will open a dialog with more details

  // Use React Query to fetch user activity stats
  const { data: rewards = [], isLoading} = useQuery(
    [QUERY_KEYS.USER.REWARDS_HISTORY],
    rewardsHistory, {
    refetchInterval: 1000 * 10, // Auto-refresh every 10 secs, even if data is fresh
    refetchIntervalInBackground: false,   // Do not poll when browser tab is in the background (even if data is stale)
    staleTime: 1000 * 10,           // Consider fresh for 10 seconds
    refetchOnWindowFocus: true,     // Refetching on tab focus, and data is stale
    refetchOnMount: true,            // Refetching on component mount, and data is stale
    keepPreviousData: true ,          // Keep previous data while fetching new data
    retry: (failureCount, error: any) => {
      const status = error?.status;
      // Retry once if it's NOT one of these status codes
      return failureCount < 1 && ![400, 401, 404].includes(status);
    },
    retryDelay: () => 4000, // 4s delay before the single retry
  });
  
  
  return (
    <DialogRoot
      scrollBehavior="inside"
      size="md"
      onOpenChange={() => {
        setIsOpen(!isOpen);
      }}
      onCloseChange={() => {
        setIsOpen(!isOpen);
      }}
    >
      <div className={styles.wrapper}>
        <Table.Root size="lg">
          <Table.Header>
            <Table.Row>
              <Table.ColumnHeader>
                <Text variant={'medium'} nativeClassname={styles.white}>
                  Game Name
                </Text>
              </Table.ColumnHeader>
              <Table.ColumnHeader>
                <Text variant={'medium'} nativeClassname={styles.white}>
                  Reward Completed
                </Text>
              </Table.ColumnHeader>
              {width > BREAKPOINTS.LG ? (
                <>
                  <Table.ColumnHeader>
                    <Text variant={'medium'} nativeClassname={styles.white}>
                      Earned
                    </Text>
                  </Table.ColumnHeader>

                  <Table.ColumnHeader>
                    <Text variant={'medium'} nativeClassname={styles.white}>
                      Completion Time
                    </Text>
                  </Table.ColumnHeader>

                  <Table.ColumnHeader>
                    <Text variant={'medium'} nativeClassname={styles.white}>
                      Status
                    </Text>
                  </Table.ColumnHeader>
                </>
              ) : (
                <Table.ColumnHeader></Table.ColumnHeader>
              )}
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {/* Show placeholder of rewards history skeleton while data is being fetched for the 1st time */}
            {isLoading ? (
              <TabsSkeleton />
            ) : rewards?.length ? (
              rewards.map((item: any) => (
                <Table.Row key={`${item.event_name}_${item.event_time}`}>
                  <Table.Cell>{toTitleCase(item.game_name)}</Table.Cell>
                  <Table.Cell>{toTitleCase(item.reward_name)}</Table.Cell>
                  {width > BREAKPOINTS.LG ? (
                    <>
                      <Table.Cell>
                        <div className={styles.flex}>
                          <CashIcon />{item.event_value_str}
                        </div>            
                      </Table.Cell>
                      <Table.Cell>{item.event_time}</Table.Cell>
                      <Table.Cell>{toTitleCase(item.status)}</Table.Cell>
                    </>
                  ) : (
                    <Table.Cell>
                      <DialogTrigger>
                        <div
                          className={styles.chevron}
                          onClick={() => {
                            setActiveItem(item);
                          }}
                        >
                          <IoChevronForwardOutline />
                        </div>
                      </DialogTrigger>
                    </Table.Cell>
                  )}
                </Table.Row>
              ))
            ) : (
              <Table.Row>
                <Table.Cell>
                  You have not completed any milestones yet...
                </Table.Cell>
              </Table.Row>
            )}
          </Table.Body>
        </Table.Root>
      </div>
      <Dialog isOpen={isOpen} contentClassNames={styles.zeroPadding} isForgot={false}>
        {activeItem ? <DialogContent data={activeItem} /> : <></>}
      </Dialog>
    </DialogRoot>
  );
};

export default Completed;
